import React from "react"
import { Grid } from "@mui/material"
import { DrawerSeeker } from "@ui-seeker/core"
import { autoEuropeProviderNormalizationDrawerData, isAutoEuropeProviderNormalizationDrawerOpen } from "Pages/AutoEuropeTool/ProviderNormalization/@signals"
import AutoEuropeProviderNormalizationFooter from "Pages/AutoEuropeTool/ProviderNormalization/@components/Footer"
import AutoEuropeProviderNormalizationProviderField from "Pages/AutoEuropeTool/ProviderNormalization/@components/ProviderField"
import AutoEuropeProviderNormalizationAutoEuropeProviderField from "Pages/AutoEuropeTool/ProviderNormalization/@components/AutoEuropeProviderField"
import AutoEuropeProviderNormalizationFilterModeField from "Pages/AutoEuropeTool/ProviderNormalization/@components/FilterModeField"

export default function AutoEuropeProviderNormalizationDrawer({ onSubmit, isLoading }) {
	return <DrawerSeeker
		title={autoEuropeProviderNormalizationDrawerData.value._isEditing ? "Edit Provider Normalization" : "Create Provider Normalization"}
		anchor="right"
		width="40%"
		variant="persistent"
		isOpen={isAutoEuropeProviderNormalizationDrawerOpen.value}
		customFooter={<AutoEuropeProviderNormalizationFooter onSubmit={onSubmit} isLoading={isLoading}/>}
	>
		<Grid container spacing={3}>
			<Grid item xs={12}>
				<AutoEuropeProviderNormalizationProviderField/>
			</Grid>
			<Grid item xs={12}>
				<AutoEuropeProviderNormalizationAutoEuropeProviderField/>
			</Grid>
			<Grid item xs={12}>
				<AutoEuropeProviderNormalizationFilterModeField/>
			</Grid>
		</Grid>
	</DrawerSeeker>
}
